import i18n from './../../../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../../../core/components/input-widget/BaseModel";

export default class Clerk extends BaseModel {
  name = null;
  language = null;
  language_uuid = null;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    name: 'required',
  };

  attributeLabels = {
    name: i18n.t('Clerk Name'),
    language: i18n.t('Clerk Language'),
    language_uuid: i18n.t('Clerk Language'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(Clerk);
